<template>
  <div class="material-preview">
    <div class="header">
      <h1>{{ title }}</h1>
      <p v-if="files.length">共 {{ files.length }} 个文件</p>
      <p v-else>加载中...</p>
    </div>

    <div v-if="error" class="empty">{{ error }}</div>

    <div v-if="files.length" class="section">
      <div class="section-title">店端上传材料（{{ files.length }}个文件）</div>
      <div class="grid">
        <div class="card" v-for="(f, i) in files" :key="i">
          <!-- 图片 -->
          <img v-if="isImage(f.ext)" :src="f.url" loading="lazy" @click="showOverlay(f.url)" />
          <!-- 视频 -->
          <video v-else-if="isVideo(f.ext)" controls preload="none"><source :src="f.url" /></video>
          <!-- 录音 -->
          <audio v-else-if="isAudio(f.ext)" controls preload="none" style="width:100%;padding:16px"><source :src="f.url" /></audio>
          <!-- 其他文件：下载 -->
          <a v-else class="file-download" :href="f.url" target="_blank" download>
            <div class="file-icon">{{ getIcon(f.ext) }}</div>
            <div>
              <div class="file-name">{{ f.name }}</div>
              <div class="file-action">点击下载</div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- 图片放大 -->
    <div class="overlay" v-if="overlayUrl" @click="overlayUrl = ''">
      <img :src="overlayUrl" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaterialPreview',
  data() {
    return {
      title: '材料预览',
      files: [],
      error: '',
      overlayUrl: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const itemId = this.$route.params.itemId
      if (!itemId) { this.error = '缺少参数'; return }
      try {
        const res = await fetch(`/api/Appeal/material/data/${itemId}`)
        const json = await res.json()
        // Furion 包装格式: { data: { errcode, title, files }, ... }
        const data = json.data || json
        if (data.errcode !== 0) {
          this.error = data.message || '加载失败'
          return
        }
        this.title = data.title || '材料预览'
        this.files = data.files || []
        if (this.files.length === 0) this.error = '该指标暂无店端上传材料'
      } catch (e) {
        this.error = '请求失败：' + (e.message || '')
      }
    },
    isImage(ext) { return ['.jpg','.jpeg','.png','.gif','.bmp','.webp','.svg'].includes(ext) },
    isVideo(ext) { return ['.mp4','.mov','.avi','.webm','.mkv','.m4v'].includes(ext) },
    isAudio(ext) { return ['.mp3','.wav','.ogg','.aac','.m4a','.wma'].includes(ext) },
    getIcon(ext) {
      if (['.pdf'].includes(ext)) return '📄'
      if (['.xls','.xlsx','.csv'].includes(ext)) return '📊'
      if (['.doc','.docx'].includes(ext)) return '📝'
      if (['.ppt','.pptx'].includes(ext)) return '📑'
      if (['.zip','.rar','.7z'].includes(ext)) return '📦'
      return '📎'
    },
    showOverlay(url) { this.overlayUrl = url }
  }
}
</script>

<style scoped>
.material-preview { min-height: 100vh; background: #f0f2f5; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
.header { background: linear-gradient(135deg, #1a73e8, #4285f4); color: #fff; padding: 20px 24px; }
.header h1 { font-size: 18px; font-weight: 500; }
.header p { font-size: 13px; opacity: 0.85; margin-top: 4px; }
.section { margin: 16px; }
.section-title { font-size: 15px; font-weight: 600; color: #1a73e8; margin-bottom: 12px; padding-left: 10px; border-left: 3px solid #1a73e8; }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 12px; }
.card { background: #fff; border-radius: 10px; overflow: hidden; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }
.card img { width: 100%; display: block; cursor: pointer; }
.card video, .card audio { width: 100%; display: block; }
.file-download { display: flex; align-items: center; padding: 16px; gap: 12px; text-decoration: none; color: #333; }
.file-download:hover { background: #f5f5f5; }
.file-icon { width: 40px; height: 40px; border-radius: 8px; background: #e8f0fe; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
.file-name { font-size: 13px; word-break: break-all; }
.file-action { font-size: 12px; color: #1a73e8; margin-top: 2px; }
.overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.85); z-index: 999; display: flex; justify-content: center; align-items: center; cursor: pointer; }
.overlay img { max-width: 95%; max-height: 95%; object-fit: contain; }
.empty { text-align: center; padding: 60px 20px; color: #999; font-size: 16px; }
</style>
